import { useEffect, useState } from "react"
import { Modal } from "flowbite-react"
import { useToastContext } from "../../../../common/components/ui/toast/toast.context"
import Loading from "../../../../common/components/ui/loading/Loading"
import FormAddNotesOperationalManagement from "../forms/FormAddNotesOperationalManagement"
import { IOperationalManagement } from "../../../../types/operational-management"
import { addNotesOperationalManagement } from "../../../../common/services/operational-management"

type Props = {
  operationalManagement: IOperationalManagement
  onClose: () => void
}

export default function ModalAddNotesOperationalManagement({ operationalManagement: initialData, onClose }: Props) {
  const [operationalManagement, setOperationalManagement] = useState<IOperationalManagement | null>(null)
  const { showToast } = useToastContext()
  const [formRequestErrors] = useState([])

  const notifySuccess = (text: string) => showToast({ text, type: 'success' })
  const notifyError = (text: string) => showToast({ text, type: 'error' })

  const handleCloseModal = () => {
    onClose()
  }

  useEffect(() => {
    setOperationalManagement(initialData)
  }, [initialData])

  async function submitAddNotesOperationalManagement(content: string, expectedResolutionDate: string) {
    if (!operationalManagement) {
      notifyError('Informações da gestão operacional não disponíveis.')
      return { ok: false }
    }

    try {
      if (!operationalManagement._id) {
        notifyError('ID da gestão operacional não disponível.')
        return { ok: false }
      }

      const formatedDate = new Date(expectedResolutionDate);
      const status = operationalManagement.status;
      const response = await addNotesOperationalManagement(
        operationalManagement._id,
        {
          content,
          expectedResolutionDate: formatedDate,
          status,
        }
      );
      const { ok } = response

      if (ok) {
        setOperationalManagement(null)
        notifySuccess(`Observação adicionada com sucesso!`)
        handleCloseModal()
        return { ok }
      } else {
        notifyError(`Erro ao tentar adicionar a observação`)
        return { ok: false }
      }
    } catch (err) {
      notifyError('Erro ao tentar salvar observação, tente novamente')
      return {
        ok: false,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any)?.message || 'Erro desconhecido', path: [] }],
      }
    }
  }

  return (
    <Modal
      size='5xl'
      className='relative'
      show={true}
      onClose={handleCloseModal}
    >
      <Modal.Header className='text-black'>
        <div className="flex items-center justify-start gap-3 text-black">
          <span>
            {`Adicionar Observação - ${operationalManagement?.licensePlate || 'Carregando...'}`}
          </span>
        </div>
      </Modal.Header>
      <Modal.Body
        className='w-full relative border-gray flex flex-col text-black'
        style={{ minHeight: 'calc(50vh - 300px)', height: 'calc(100vh - 300px)' }}
      >
        {operationalManagement ? (
          <FormAddNotesOperationalManagement
            data={operationalManagement}
            onSubmit={submitAddNotesOperationalManagement}
            formRequestErrors={formRequestErrors}
          />
        ) : (
          <Loading />
        )}
      </Modal.Body>
    </Modal>
  )
}